// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import Icon_visa from '../img/payment_methods/visa_2023.svg';
import Icon_mastercard from '../img/payment_methods/mastercard_2023.svg';
import Icon_discover from '../img/payment_methods/discover.svg';
import Icon_amex from '../img/payment_methods/amex_2023.svg';
import Icon_paypal from '../img/payment_methods/paypal_2023.svg';

export const cc_map = {
    visa: {
        icon: <Icon_visa width={48} height={33}/>,
        title: 'Visa',
    },
    mastercard: {
        icon: <Icon_mastercard width={48} height={33}/>,
        title: 'Mastercard',
    },
    amex: {
        icon: <Icon_amex width={48} height={33}/>,
        title: 'American Express',
    },
    discover: {
        icon: <Icon_discover width={48} height={33}/>,
        title: 'Discover',
    },
};

export const cc_map_small = {
    visa: {
        icon: <Icon_visa width={34} height={24}/>,
        title: 'Visa',
    },
    mastercard: {
        icon: <Icon_mastercard width={34} height={24}/>,
        title: 'Mastercard',
    },
    amex: {
        icon: <Icon_amex width={34} height={24}/>,
        title: 'American Express',
    },
    discover: {
        icon: <Icon_discover width={34} height={24}/>,
        title: 'Discover',
    },
    paypal: {
        icon: <Icon_paypal width={34} height={24}/>,
        title: 'PayPal',
    },
};
